export default __webpack_public_path__ + "static/poster-0716994fdd598b534878ca73e49600e3.jpg";